import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

//import images
import { useUserContext } from 'context/UserContext';
import { logoutUser } from 'services/authService';
import { removeToken } from 'helpers/api_helper';

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const { setToken } = useUserContext();
  const [user, setUser] = useState(
    JSON.parse(sessionStorage.getItem('authUser')),
  );

  const [userName, setUserName] = useState('Admin');
  const [nameInitials, setNameInitials] = useState('A');
  const [role, setRole] = useState('Admin');

  useEffect(() => {
    if (
      user &&
      typeof user === 'object' &&
      'name' in user &&
      Array.isArray(user.accessLevels)
    ) {
      setUserName(user.name);

      setNameInitials(
        user.name
          ?.split(' ')
          .filter(Boolean)
          .map(part => part[0].toUpperCase())
          .join('') || 'U',
      );

      setRole(user.accessLevels[0]);
    }
  }, [user]);

  useEffect(() => {
    const handleProfileUpdate = () => {
      const storedUser = sessionStorage.getItem('authUser');
      const parsedUser = storedUser ? JSON.parse(storedUser) : null;
      setUser(parsedUser);
    };

    window.addEventListener('profileUpdated', handleProfileUpdate);

    return () =>
      window.removeEventListener('profileUpdated', handleProfileUpdate);
  }, []);

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  const logout = async () => {
    setToken('');
    removeToken();
    logoutUser();
    navigate('/login');
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: '50px',
                height: '50px',
                backgroundColor: '#343a40', // dark grey
                color: 'white',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                fontSize: '14px',
              }}
            >
              {nameInitials}
            </div>
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {' '}
                {userName || 'Admin'}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {role || 'Admin'}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">Welcome {userName}!</h6>
          {/* <DropdownItem className="p-0">
            <Link to="/apps-chat" className="dropdown-item">
              <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Messages</span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <Link to={'#'} className="dropdown-item">
              <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Taskboard</span>
            </Link>
          </DropdownItem> */}
          {/* <DropdownItem className="p-0">
            <Link to="/pages-faqs" className="dropdown-item">
              <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Help</span>
            </Link>
          </DropdownItem>
          <div className="dropdown-divider"></div>
          <DropdownItem className="p-0">
            <Link to="/pages-profile" className="dropdown-item">
              <i className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">
                Balance : <b>$5971.67</b>
              </span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <Link to="/pages-profile-settings" className="dropdown-item">
              <span className="badge bg-success-subtle text-success mt-1 float-end">
                New
              </span>
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Settings</span>
            </Link>
          </DropdownItem> */}
          {/* <DropdownItem className="p-0">
            <Link to="/auth-lockscreen-basic" className="dropdown-item">
              <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Lock screen</span>
            </Link>
          </DropdownItem> */}
          <DropdownItem className="p-0">
            <Link to="/profile" className="dropdown-item">
              <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Profile</span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0" onClick={logout}>
            <Link to="#" className="dropdown-item">
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle" data-key="t-logout">
                Logout
              </span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
